export const systemCurrency = () => {
    if(process.env.VUE_APP_REGION === 'US'){
      return 'USD';
    } else {
        return 'AUD';
    }
  }